export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('carespot');

    if (serializedState === null) {
      return undefined;
    }

    return JSON.parse(serializedState);
  } catch (err) {
    console.log(err);
    return undefined;
  }
};

export const saveState = state => {
  try {
    localStorage.setItem('carespot', JSON.stringify(state));
  } catch (err) {
    console.log(err);
    // TODO: Log errors
  }
};
